import React, { useState } from 'react';
import { Box, Button, Popover, TextField, IconButton, Typography } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';

function TassFeedbackButton({ onFeedback }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setFeedbackText('');
  };

  const handleSubmit = () => {
    if (onFeedback) {
      onFeedback(feedbackText || 'Marked as incorrect');
    }
    setSubmitted(true);
    handleClose();
  };

  if (submitted) {
    return (
      <Typography variant="caption" sx={{ color: 'text.disabled', fontStyle: 'italic' }}>
        Feedback sent
      </Typography>
    );
  }

  return (
    <>
      <Button
        size="small"
        onClick={handleClick}
        sx={{
          fontSize: '0.65rem',
          textTransform: 'none',
          color: 'text.secondary',
          minWidth: 'auto',
          p: 0,
          '&:hover': { color: 'error.main', backgroundColor: 'transparent' }
        }}
      >
        Incorrect?
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box sx={{ p: 1.5, width: 240 }}>
          <Typography variant="caption" sx={{ fontWeight: 600, mb: 0.5, display: 'block' }}>
            What was wrong?
          </Typography>
          <Box display="flex" alignItems="flex-end" gap={0.5}>
            <TextField
              size="small"
              fullWidth
              multiline
              maxRows={3}
              placeholder="Optional details..."
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
              variant="outlined"
              sx={{ '& .MuiOutlinedInput-root': { fontSize: '0.75rem' } }}
            />
            <IconButton size="small" onClick={handleSubmit} color="primary" aria-label="Send feedback">
              <SendIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Popover>
    </>
  );
}

export default TassFeedbackButton;
